import React from 'react';
import { useUnistyles } from 'react-native-unistyles';

const HtmlBlock = ({ block, isSelected, onSelect, onUpdate, editMode }) => {
    const { theme: { colors, fonts } } = useUnistyles();
    const { content, styles: blockStyles } = block;

    const padding = `${blockStyles.paddingTop ?? 10}px ${blockStyles.paddingRight ?? 20}px ${blockStyles.paddingBottom ?? 10}px ${blockStyles.paddingLeft ?? 20}px`;

    if (editMode && isSelected) {
        return (
            <div style={{ padding }}>
                <textarea
                    value={content.rawHtml || ''}
                    onChange={(e) => onUpdate(block.id, { ...block.content, rawHtml: e.target.value })}
                    rows={8}
                    placeholder="Enter raw HTML..."
                    style={{
                        width: '100%',
                        padding: 8,
                        fontFamily: 'monospace',
                        fontSize: 12,
                        backgroundColor: colors.background,
                        color: colors.text,
                        border: `1px solid ${colors.border}`,
                        borderRadius: 4,
                        resize: 'vertical',
                        boxSizing: 'border-box',
                    }}
                />
            </div>
        );
    }

    return (
        <div
            onClick={(e) => { e.stopPropagation(); onSelect(block.id); }}
            style={{
                padding,
                backgroundColor: blockStyles.backgroundColor || 'transparent',
                outline: isSelected ? `2px solid ${colors.primary}` : '2px solid transparent',
                outlineOffset: '-2px',
                cursor: 'pointer',
                minHeight: 40,
            }}
        >
            {content.rawHtml ? (
                <div dangerouslySetInnerHTML={{ __html: content.rawHtml }} />
            ) : (
                <div style={{ color: colors.textTertiary, fontStyle: 'italic', fontSize: 13, fontFamily: fonts.body }}>
                    Raw HTML block — click to edit
                </div>
            )}
        </div>
    );
};

export default HtmlBlock;
